import {
  Grid,
  Flex,
  Icon,
  LinkBox,
  LinkOverlay,
  Skeleton,
} from "@chakra-ui/react";
import { MdArrowForwardIos } from "react-icons/md";
import { Link } from "react-router-dom";

import {
  PageContent,
  PageHeader,
  PageLayout,
  PageTitle,
} from "@/components/page";
import { useNurseries } from "@/hooks";
import { INursery } from "@/types/data";

function NurseryCard({ id, name }: INursery) {
  return (
    <LinkBox
      p="4"
      borderWidth="1px"
      borderRadius="sm"
      _hover={{
        borderColor: "border.info",
        cursor: "pointer",
      }}
      bg="white"
    >
      <Flex gap="4" alignItems="center">
        <LinkOverlay asChild flex="1">
          <Link to={`/nurseries/${id}/`}>{name}</Link>
        </LinkOverlay>
        <Icon>
          <MdArrowForwardIos />
        </Icon>
      </Flex>
    </LinkBox>
  );
}

function NurseryList() {
  const { data, isPending } = useNurseries();

  return (
    <PageLayout>
      <PageHeader>Coracle</PageHeader>
      <PageTitle>My Nurseries</PageTitle>
      <PageContent>
        {isPending && (
          <Grid templateColumns="repeat(auto-fit, minmax(14rem, 1fr))" gap={4}>
            {Array.from(Array(4)).map(() => (
              <Skeleton
                bg="white/25"
                borderColor="border"
                borderWidth={1}
                key={crypto.randomUUID()}
                h={14}
                w="100%"
              />
            ))}
          </Grid>
        )}
        {!isPending && !data?.count ? (
          <p>No nurseries found.</p>
        ) : (
          data && (
            <Grid
              templateColumns="repeat(auto-fit, minmax(14rem, 1fr))"
              gap={4}
            >
              {data.results.map(({ id, name }: INursery) => (
                <NurseryCard key={id} id={id} name={name} />
              ))}
            </Grid>
          )
        )}
      </PageContent>
    </PageLayout>
  );
}

export default NurseryList;
